export const usePersonDetailStyles = () => {
    return {
        container: {
            height: '100%',
            overflow: 'hidden',
            width: '100%'
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            gap: (theme) => theme.spacing(2),
            marginBottom: (theme) => theme.spacing(3)
        },
        backButton: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: (theme) => theme.palette.background.paper,
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
                backgroundColor: (theme) => theme.palette.grey[100],
                transform: 'scale(1.05)'
            }
        },
        headerTitle: {
            fontSize: '24px',
            fontWeight: 600,
            color: (theme) => theme.palette.grey[900]
        },
        mainLayout: {
            display: 'flex',
            height: '100%',
            width: '100%'
        },
        leftPanel: {
        // minWidth:"344px",
        // flexShrink: 0
        },
        rightPanel: {
        // flex: 1,
        // minWidth: 0
        }
    };
};
